<template>
  <el-dialog :visible.sync="visible" width="500px" @close="onClose" append-to-body>
    <div class="text-center p-6">
      <i class="bx bx-shield text-4xl text-purple-700 mb-4 bg-purple-100 rounded-full p-4"></i>

      <h1 class="text-2xl font-bold text-gray-800">
        🔒 Mejoramos tu experiencia en Samii
      </h1>

      <p class="text-md text-gray-600 mb-4 font-bold">
        Ahora tu sesion ya no se cerrara automaticamente
      </p>

      <p class="text-md text-gray-600 mb-4">
        Puedes elegir si deseas que la pantalla se bloquee por inactividad para proteger tu informacion.
      </p>

      <el-radio-group v-model="selectedDuration" class="text-left flex flex-col space-y-4 mb-8">
        <el-radio v-for="option in options" :key="option.value" :value="option.value" :label="option.value"
          class="w-full border border-gray-300 rounded-lg p-4 font-bold">
          {{ option.label }}
        </el-radio>
      </el-radio-group>

      <span slot="footer" class="dialog-footer flex flex-col space-y-2">
        <el-button type="primary" @click="save" class="w-full text-md font-bold">
          👉 Guardar y continuar
        </el-button>

        <p>Podras cambiar esto en Configuracion > Seguridad</p>

        <a @click="onClose" class="w-full text-md font-bold text-gray-600">
          Configurar después
        </a>
      </span>
    </div>
  </el-dialog>
</template>

<script>
import AccountService from '@/services/AccountService';
import { mapState } from 'vuex';

const MINUTES_IN_YEAR = 525600;

export default {
  name: 'SessionDurationDialog',
  data() {
    return {
      visible: false,
      selectedDuration: MINUTES_IN_YEAR, // Valor por defecto (1 año en minutos)
    };
  },
  computed: {
    ...mapState({
      accountId: (state) => state.account.id,
      sessionDuration: (state) => state.account.sessionDurationMinutes || MINUTES_IN_YEAR, // Valor por defecto si no está configurado
    }),

    options() {
      return [
        { label: 'Nunca bloquear (recomendado)', value: MINUTES_IN_YEAR }, // 1 año en minutos
        { label: 'Bloquear después de 15 minutos', value: 15 },
        { label: 'Bloquear después de 1 hora', value: 60 },
      ];
    }
  },
  methods: {
    show() {
      this.selectedDuration = this.sessionDuration;
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    async save() {
      try {
        const { token } = await AccountService.updateSessionDuration({
          accountId: this.accountId,
          sessionDurationMinutes: this.selectedDuration,
        });

        // Actualizamos el store con la nueva duración de sesión y el nuevo token
        this.$store.dispatch('account/replaceSessionDuration', this.selectedDuration);
        this.$store.dispatch("auth/store", { token: token });

        this.$toastr.s('Tu configuración de seguridad ha sido guardada.');
        this.onClose();
      } catch (error) {
        this.$toastr.e('Hubo un error al guardar tu configuración.');
      }
    },
  },
};
</script>
